// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Fn-z","imageAndVideoCount":"Gn-z","imageAndVideoContainer":"Hn-z","viewAllReviews":"In-z"};